import axios from '@/plugins/http/axios.js';
import config from "@/views/purchase_reconciliation/config/purchase_reconciliation_api.js";
import PathUri from '@/utils/path_uri';

const _pathUri = new PathUri(config.port, config.context);

export const service = {

    getPurchaseReconciliation: (idGroup, idEmpresa, idUsuario) => {
        return axios({
            method: 'get',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/transaction`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },

    getTypeChangeState: (idGroup, idEmpresa, idUsuario) => {
        return axios({
            method: 'get',
            url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/transaction/states`,
            headers: {
                'idEmpresa': idEmpresa,
                'idUsuario': idUsuario
            }
        })
    },

    postChangeState: ({ idGroup, idEmpresa, idUsuario, postChangeState }) => {
        return axios.post(
             `${config.baseUrl + _pathUri.generateUri() + idGroup}/transaction/conciliation`,
             {
                transactionId: postChangeState.transactionId,
                stateId: postChangeState.transactionStateId,
                observationMessage: postChangeState.observationMessage,
                isReconcilable: postChangeState.isReconcilable
             },
             {
                 headers: {
                     'Content-Type': 'application/json',
                     'idEmpresa': idEmpresa,
                     'idUsuario': idUsuario
                 }
             }
         )
     },
};
